export default __webpack_public_path__ + "static/images/blog-cove-bottle-dt.a39229f60335023b1752d0ae383fd88c.jpg";